var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "general/user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15C18 11.6863 20.6863 9 24 9C27.3137 9 30 11.6863 30 15C30 18.3137 27.3137 21 24 21C20.6863 21 18 18.3137 18 15ZM24 5C18.4772 5 14 9.47715 14 15C14 20.5228 18.4772 25 24 25C29.5228 25 34 20.5228 34 15C34 9.47715 29.5228 5 24 5ZM16 27C13.1216 27 10.3904 27.8771 8.34385 29.6095C6.26556 31.3688 5 33.9275 5 37V40C5 41.6569 6.34315 43 8 43H40C41.6569 43 43 41.6569 43 40V37C43 33.9275 41.7344 31.3688 39.6562 29.6095C37.6096 27.8771 34.8784 27 32 27H16ZM9 37C9 35.102 9.74916 33.6606 10.9282 32.6625C12.139 31.6376 13.9079 31 16 31H32C34.0921 31 35.861 31.6376 37.0718 32.6625C38.2508 33.6606 39 35.102 39 37V39H9V37Z",
    fill: "#4E5969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.056f6eb710f53d54110a274f825b49c3.svg";
export { ForwardRef as ReactComponent };